"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
exports.Type = prelude_1.t.strict({
    wpApiBase: prelude_1.t.NonEmptyString,
    homeUrl: prelude_1.t.NonEmptyString
}, 'Config');
//# sourceMappingURL=Config.js.map